import { IUserActiveBlock } from '@gig/magic-sdk/dist/adapter/users/getUserActiveBlocks';

export interface IResponsibleGamingState {
    /**
     * If the user needs to set the betting limits
     */
    requireBettingLimit: boolean | null;
    /**
     * If the active user blocks have already been fetched for this session
     */
    timeOutResolved: boolean;
    /**
     * If the user is currently in a Time-out period
     */
    isTimedOut: boolean;
    /**
     * If the Time-out modal is currently displayed
     */
    isModalOpen: boolean;
    /**
     * The most recent active Time-out block of the user
     */
    blocks: Partial<IUserActiveBlock>;
}

export const RESPONSIBLE_GAMING_NAMESPACE = 'responsible_gaming';
export const SET_REQUIRE_BETTING_LIMIT = 'SET_REQUIRE_BETTING_LIMIT';
export const SET_TIMEOUT_STATE = 'SET_TIMEOUT_STATE';
export const SET_MODAL_OPEN_STATE = 'SET_MODAL_OPEN_STATE';
